import * as uuidv4 from 'uuid/v4';

// generate a mongo ObjectId
export const ObjectId = (m = Math, d = Date, h = 16, s = t => m.floor(t).toString(h)) =>
  s(d.now() / 1000) + ' '.repeat(h).replace(/./g, () => s(m.random() * h));

// generate a guid/uuid
export const Uuid = () => uuidv4();
